/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreApiService } from '../core-api-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getConfigurations } from '../fn/vpn/get-configurations';
import { GetConfigurations$Params } from '../fn/vpn/get-configurations';
import { startConfiguration } from '../fn/vpn/start-configuration';
import { StartConfiguration$Params } from '../fn/vpn/start-configuration';
import { stopConfiguration } from '../fn/vpn/stop-configuration';
import { StopConfiguration$Params } from '../fn/vpn/stop-configuration';
import { VpnConfigurationDto } from '../models/vpn-configuration-dto';

@Injectable({ providedIn: 'root' })
export class VpnAPI extends CoreApiService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConfigurations()` */
  static readonly GetConfigurationsPath = '/vpn/configurations';

  /**
   * List existing VPN configurations of the underlying VPNGate.
   *
   * Returns a list of VPN configurations. All configurations are read-only and can only be requested for information purposes. The configurations can only be changed on deployment timeof the VPNGate via the documented options of VPNGate. The configuration will be identified by the commonName.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigurations$Response(params?: GetConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VpnConfigurationDto>>> {
    return getConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * List existing VPN configurations of the underlying VPNGate.
   *
   * Returns a list of VPN configurations. All configurations are read-only and can only be requested for information purposes. The configurations can only be changed on deployment timeof the VPNGate via the documented options of VPNGate. The configuration will be identified by the commonName.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigurations(params?: GetConfigurations$Params, context?: HttpContext): Observable<Array<VpnConfigurationDto>> {
    return this.getConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VpnConfigurationDto>>): Array<VpnConfigurationDto> => r.body)
    );
  }

  /** Path part for operation `startConfiguration()` */
  static readonly StartConfigurationPath = '/vpn/configurations/{commonName}/start';

  /**
   * Start/activate a configuration by its commonName.
   *
   * Configurations in VPNGate are fixed on deployment time, but they can be started/activate on runtime by calling this endpoint.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  startConfiguration$Response(params: StartConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return startConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Start/activate a configuration by its commonName.
   *
   * Configurations in VPNGate are fixed on deployment time, but they can be started/activate on runtime by calling this endpoint.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  startConfiguration(params: StartConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.startConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `stopConfiguration()` */
  static readonly StopConfigurationPath = '/vpn/configurations/{commonName}/stop';

  /**
   * Stop/deactivate a configuration by its commonName.
   *
   * Configurations in VPNGate are fixed on deployment time, but they can be stopped/deactivated on runtime by calling this endpoint.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stopConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  stopConfiguration$Response(params: StopConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return stopConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Stop/deactivate a configuration by its commonName.
   *
   * Configurations in VPNGate are fixed on deployment time, but they can be stopped/deactivated on runtime by calling this endpoint.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stopConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stopConfiguration(params: StopConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.stopConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
